export const ADDRESS = 'ADDRESS';
export const EXISTING_ADDRESS_TRUE = 'EXISTING_ADDRESS_TRUE';
export const EXISTING_ADDRESS_FALSE = 'EXISTING_ADDRESS_FALSE';
